import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { PageName } from '@/enums/pageName'
import { getPageName } from '@/utils/urlUtils'

import { Less } from '@/shared/icons/Less'
import { LogoOrgfit } from '@/shared/icons/LogoOrgfit'

import { TProgressBarProps } from './types'

export const ProgressBarOrgFit = ({ pagesConfig, pageOrder }: TProgressBarProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const totalStep = useMemo<number>((): number => {
    let counter = 0
    for (const pageName in pagesConfig) {
      const pageConfig = pagesConfig[pageName as PageName]
      if (pageConfig && pageConfig.hasOwnProperty('progress')) {
        ++counter
      }
    }
    return counter
  }, [pagesConfig])
  const pageName = getPageName(location.pathname)
  const currentPageConfig = pagesConfig[pageName]

  const back = () => {
    navigate(-1)
  }

  const paymentScreenPage = pageName === PageName.paymentScreen
  const isShow = !paymentScreenPage && currentPageConfig && currentPageConfig.pageNumber
  const isFirstPage = pageName === pageOrder?.[0]

  const showBack = Boolean(paymentScreenPage || (isShow && !isFirstPage))

  const className = `header-page-${pageName}`

  return (
    <header id="header" className={className}>
      <div className="logo-container">
        <div className={'back-container' + (showBack ? '' : ' hidden')}>
          <Less onClick={back} />
        </div>
        <LogoOrgfit />
      </div>

      <div className="progress-bar-wrapper">
        <div className={'progress-bar' + (isShow ? '' : ' hidden')}>
          <div className="progress" style={{ width: `${currentPageConfig?.progress}%` }}></div>
        </div>
        <div className={'step-container' + (isShow ? '' : ' hidden')}>
          <span>{currentPageConfig?.pageNumber}</span>/{totalStep}
        </div>
      </div>
    </header>
  )
}
